import { render } from "./Icon.vue?vue&type=template&id=031ff5a7&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=031ff5a7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-031ff5a7"

export default script